module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmuskel1-201be473369aed4c573af95e0790c8e1.jpg";